import { automationTickerItems } from "./radarData";

// Ticker horizontal infinito con las automatizaciones — se duplica la lista
// una vez para que el loop de "tick" (translateX -50%) sea continuo.
export function EcoTicker() {
  const items = [...automationTickerItems, ...automationTickerItems];

  return (
    <div className="eco-ticker">
      <div className="eco-ticker__track">
        {items.map((item, i) => (
          <span key={`${item.label}-${i}`} className="eco-ticker__item">
            <span className="eco-ticker__label">{item.label}</span>
            <span className="eco-ticker__value">{item.value}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
